import { respondTo } from 'assets/styled/breakpoints';
import { COLORS } from 'assets/styled/colors';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 50rem 0;
  max-width: 1440rem;
  width: 100%;

  ${respondTo.smallLaptop`
    padding: 50rem 15rem;
  `}

  ${respondTo.smallTablet`
    padding: 20rem 15rem;
  `}
`;

export const Heading = styled.h2`
  font-size: 40rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  margin-bottom: 20rem;

  ${respondTo.smallTablet`
    font-size: 30rem;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 30rem;
  width: 100%;

  ${respondTo.midTablet`
    flex-direction: column;
  `}
`;

export const InsideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30rem;
  width: 100%;
`;
